export default __webpack_public_path__ + "static/char-05-anr-6f1d18e1c6c8973ba84b5f8f35ca1a28.webp";